export const CONTACT_SALES_URL = 'https://www.qodo.ai/contact/';

/** i18n key suffixes for the Team Pro "What's included" feature checklist, in display order. */
export const FEATURE_KEYS = [
  'agentic-review',
  'rules',
  'integrations',
  'pre-pr-skills',
  'data-retention',
  'overage-cap',
] as const;

/** i18n key suffixes for the Enterprise "What's included" feature checklist, in display order. */
export const ENTERPRISE_FEATURE_KEYS = [
  'sso',
  'governance',
  'self-learning',
  'byok',
  'single-tenant',
  'support',
] as const;

export type PlanTier = 'team-pro' | 'enterprise';
